import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { me, logout as apiLogout } from '../api/auth';
import { useBranding } from './BrandingContext';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const { resetToDefault } = useBranding();

  const logout = useCallback(async () => {
    await apiLogout();
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    setUser(null);
    // Sem isso, a marca da empresa da sessão que acabou de sair ficaria visível
    // (CSS vars + título/favicon) até o próximo loadBySlug/loadAtiva — risco real
    // de vazar nome/logo de uma empresa pra quem for usar o mesmo navegador depois.
    resetToDefault();
  }, [resetToDefault]);

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (!token) { setLoading(false); return; }

    me()
      .then(r => setUser(r.data))
      .catch(() => {
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    const handler = () => logout();
    window.addEventListener('auth:logout', handler);
    return () => window.removeEventListener('auth:logout', handler);
  }, [logout]);

  const loginSuccess = (data) => {
    localStorage.setItem('access_token', data.access_token);
    localStorage.setItem('refresh_token', data.refresh_token);
    setUser(data.usuario);
  };

  const updateUser = useCallback((data) => {
    setUser(prev => ({ ...prev, ...data }));
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, loginSuccess, logout, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
